import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Link, Outlet } from "react-router-dom";

//Media Assets
import Logo from "../assets/konch-logo.png";
import bar1 from "../assets/home/bar-1.png";
import bar2 from "../assets/home/bar-2.png";
import bar3 from "../assets/home/bar-3.png";
import icon1 from "../assets/home/Icon-1-3.png";
import icon2 from "../assets/home/Icon-2-3.png";
import icon3 from "../assets/home/Icon-3-3.png";
import shape1 from '../assets/shape1.png';

function Home() {

  const form = document.querySelector(".signup-form-primary");
  const formButton = document.querySelector(".form-button-start-primary");
  
  const onSubmit = (e) => {
    e.preventDefault();
    const input = document.querySelector(".input-email-primary").value;
    console.log(`input is ${input}`);

    const formSuccess = document.querySelector(".form-show-success");
    formSuccess?.classList?.remove("form-success");

    const formFail = document.querySelector(".form-show-failure");
    formFail?.classList.remove("form-fail");

    if(input.includes("@")&&input.includes(".")){
      formSuccess.classList.add('form-success');
    } else {
      formFail.classList.add('form-fail');  
    }
  }

  const onSubmitLower = (e) => {
    e.preventDefault();
    const input = document.querySelector(".input-email").value;
    console.log(`input is ${input}`);

    const formSuccess = document.querySelector(".lower-form-show-success");
    formSuccess?.classList?.remove("lower-form-success");

    const formFail = document.querySelector(".lower-form-show-failure");
    formFail?.classList.remove("lower-form-fail");

    if(input.includes("@")&&input.includes(".")){
      formSuccess.classList.add('lower-form-success');
    } else {
      formFail.classList.add('lower-form-fail');  
    }
  }


  return (
    <>
      <header className="container">
        <img src={Logo} className="header-logo" alt="" />
      </header>
      <main>
        <section className="primary-section container">
          <div className="primary-text">
            <h1>Online Selling, 10X Faster with AI</h1>
            <p>
              Konch is an AI-enabled app that helps sellers make product
              listings in 15 seconds. Our early prototype is coming live this
              February 2023!
            </p>
<div className="signup-container-primary">
<form className="signup-form-primary">
    <input type="text" className="input-email-primary" placeholder="Your Email Address"/>
    <button type="submit" className="form-button-start-primary" onClick={onSubmit}><p>Sign Up</p></button>
    <p className="form-show-success">Signed up! Please check your email.</p>
    <p className="form-show-failure">Please enter a proper email.</p>
  </form>

</div>
          </div>
          <div className="primary-graphics">
            <img src={bar1} alt="" className="bar-top" />
            <div className="bottom-bars">
            <img src={bar2} alt="" className="bar-bottom bar-bottom-left" />
            <img src={bar3} alt="" className="bar-bottom bar-bottom-right" />    
            </div>
          </div>
        </section>

        <section className="offerings-section">
            <p className="minitext">Our Core Offerings</p>
          <h2>Focus on selling, and let Konch automate the rest. </h2>
          {/* <p>
            Our mission is to make it faster for you to sell online by
            digitizing your products within seconds.{" "}
          </p> */}

          <div className="card-list">
          <div className="card">
              <img src={icon3} alt="" className="card-image" />
              <p className="card-text">
                Video to product photos in 15 seconds
              </p>
            </div>

            <div className="card">
              <img src={icon1} alt="" className="card-image" />
              <p className="card-text">
                Long product listings generated in 15 seconds
              </p>
            </div>
            <div className="card">
              <img src={icon2} alt="" className="card-image" />
              <p className="card-text">
                Export, plug and play within a minute
              </p>
            </div>
          </div>
        </section>

        <section className="section-numbers">
          <div className="container-numbers">


          
          <p className="minitext-light">Our numbers</p>
          <h3 className="header-numbers">The Konch AI will help you get 5X more things done with less time.</h3>
          <div className="numbers">
            <div className="number">
              <p className="number-metric">93%</p>
              <p className="number-caption">Time saved in photography</p>
            </div>
            <div className="number">
              <p className="number-metric">10k</p>
              <p className="number-caption">Photos generated</p>
            </div>
            <div className="number">
              <p className="number-metric"> 4.9</p>
              <p className="number-caption">Customer Satisfaction</p>
            </div>
          </div>
          </div>
        </section>

<section className="section-signup">
  {/* <img src={shape1} className="float-shape" alt="" /> */}
{/* 
  <div className="container-signup">

<div className="element"> </div>  
</div> */}
<p className="signup-header">Save 90% of your precious time. Join the waitlist!</p>

  <form action="" className="signup-form">
    <div className="form-flex">
    <input type="text" className="input-email" placeholder="Your Email Address"/>

    <button className="form-button-start" onClick={onSubmitLower}><p>Join Now</p></button>

    </div>
  
  </form>

  <div className="lower-form-text">
    <p className="lower-form-show-success">Signed up! Please check email.</p>
    <p className="lower-form-show-failure">Please enter a proper email.</p>

    </div>
</section>


      </main>
      <footer>
        <div className="footer-column-1">
            <img src={Logo} alt="" />
            <p className="footer-upper-text">A mission-driven AI company that aims to help the next billion sellers do business easier. Made with Love by Sellers for Sellers.</p>
            <p className="footer-lower-text">All rights reserved.</p>
        </div>
        <div className="footer-column-2 footer-stack">
            <ul>
                <li className="list-head">Products</li>
                <li>AI Photos</li>
                <li>AI Listing</li>
                <li>AI Export</li>
            </ul>
        </div>
        <div className="footer-column-3 footer-stack">
            <ul>
                <li className="list-head">Startup</li>
                <Link to={"About"} className="project">
                <li>About Us</li>
                </Link>
                
                <li>Partnership</li>
                <li>Pricing</li>
            </ul>
        </div>
        <div className="footer-column-4 footer-stack">
            <ul>
                <li className="list-head">Resources</li>
                <li>Blog</li>
                <Link to={"Job"} className="project">
                <li>Career</li>
        </Link>
                
                <li>Advocacy</li>
            </ul>
        </div>



        
      </footer>
    </>
  );
}
export default Home;
